module.exports = __webpack_public_path__ + "static/media/avatar_1.99153858.png";